<template>
    <!-- Come in TheHeader: `el-dropdown` al posto di `CDropdown`, che serviva per il comportamento. -->
    <ElDropdown placement="bottom-end" trigger="click">
        <span class="c-header-nav-link">
            <div class="c-avatar">
                <font-awesome-icon icon="user" />
            </div>
        </span>
        <template #dropdown>
            <ElDropdownMenu>
                <ElDropdownItem disabled>
                    <strong>{{ $t('yourAccount') }}</strong>
                </ElDropdownItem>
                <ElDropdownItem @click="$router.push('/change-password')">
                    <font-awesome-icon icon="key" class="mr-2" />
                    <span class="mr-2">{{ $t('changePassword') }}</span>
                </ElDropdownItem>
                <ElDropdownItem divided @click="doLogout()">
                    <font-awesome-icon icon="sign-out-alt" class="mr-2" />
                    {{ $t('logout') }}
                </ElDropdownItem>
            </ElDropdownMenu>
        </template>
    </ElDropdown>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { AUTHENTICATE } from '../../core/store/types/action-types';

export default defineComponent({
    name: 'TheHeaderDropdownAccnt',

    methods: {
        doLogout() {
            this.$store.dispatch(AUTHENTICATE, { token: null, authState: false });
        },
    },
});
</script>

<style scoped>
.c-icon {
    margin-right: 0.3rem;
}
</style>
